export const assetUrl = 'https://storage.googleapis.com/ic-website-assets/'

export const blogUrl = 'https://blog.initialized.com'
export const mobileBreak = '768px'
export const mailchimpUrl = '//initialized.us14.list-manage.com/subscribe/post?u=fc1348dbc00cb2c0bf16316a7&id=5eb33b7b3e'
